import { Injectable } from '@angular/core';
import { DataSource, ArrayStore } from 'devextreme/common/data';
import { ResourcesDataContext } from '../resources.model';
import { MobileResourceEventViewModel } from '../../viewModels/mobileData.resources.viewModel';
@Injectable()
export class ResourceListService {
  private _resourceEventsDataSource: DataSource<MobileResourceEventViewModel, string>;
  constructor() {}

  public initResourceEventsDataSource(context: ResourcesDataContext): void {
    this._resourceEventsDataSource = new DataSource(
      new ArrayStore({
        key: 'id',
        data: context?.dsResourceEvents,
      }),
    );
    this._resourceEventsDataSource.filter(['resourceTypeSelected', '=', true]);
  }

  public getResourceEvents(): DataSource<MobileResourceEventViewModel, string> {
    return this._resourceEventsDataSource;
  }

  public insertResourceEvent(resourceEvent: MobileResourceEventViewModel): void {
    this._resourceEventsDataSource.store().insert(resourceEvent);
    //TODO: Why is this necessary?
    //resourceEvent.id = undefined; // set to undefined, that persistenceService can update it -> strange!
    this._resourceEventsDataSource.reload();
  }

  public updateResourceEvent(resourceEvent: MobileResourceEventViewModel): void {
    this._resourceEventsDataSource.store().update(resourceEvent.id, resourceEvent);
    this._resourceEventsDataSource.reload();
  }

  public deleteResourceEvent(resourceEvent: MobileResourceEventViewModel): void {
    this._resourceEventsDataSource.store().remove(resourceEvent.id);
    this._resourceEventsDataSource.reload();
  }
}
